import Breadcrumbs from './Breadcrumbs.vue';
export default Breadcrumbs;
